module.exports = __webpack_public_path__ + "static/media/r11.f08fee37.jpeg";